import { Job, PreJobCheckListV2, VehicleType } from "../../../generated/nest-graphql";
import { hasRecordedInspection, isCompletedVisit } from "../vehicleHistoryData";

export const REAR_DRUM_BRAKES_YES = "Yes";
export const REAR_DRUM_BRAKES_NO = "No";

// An inspection opened and never done still carries the form's default "no drums", so it does not count.
const isInspected = (checklist?: PreJobCheckListV2 | null): checklist is PreJobCheckListV2 =>
  !!checklist && (checklist.usesRearShoesAndDrums === true || hasRecordedInspection(checklist));

/** The current job's inspection when it has one, otherwise the newest closed job's. Expects jobs newest first. */
export const latestInspection = (jobs: Job[], currentJobId?: string | null): PreJobCheckListV2 | null => {
  const current = currentJobId ? jobs.find((job) => job.id === currentJobId)?.preJobCheckListV2 : null;
  if (isInspected(current)) return current;
  return jobs.find((job) => isCompletedVisit(job) && isInspected(job.preJobCheckListV2))?.preJobCheckListV2 ?? null;
};

// Shows the record as the edit form does; an inspection's unticked box is only the default, so it never says No.
export const rearDrumBrakes = (vehicle?: VehicleType | null, inspection?: PreJobCheckListV2 | null): string | null => {
  const stored = vehicle?.vehicleTechnicalInfo?.hasDrumBrakes;
  if (stored === true || inspection?.usesRearShoesAndDrums === true) return REAR_DRUM_BRAKES_YES;
  return stored === false ? REAR_DRUM_BRAKES_NO : null;
};
